import { render, staticRenderFns } from "./SampleDropdown.vue?vue&type=template&id=52b4e3b8&"
import script from "./SampleDropdown.vue?vue&type=script&lang=js&"
export * from "./SampleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports